import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router';

import style from './style.module.less';
import { apiDispatchAuthInformation } from '@/apis/auth';
import { OrderBusinessType, UserPermissionType } from '@/components/enum';
import { PageContent } from '@/components/layout/admin/components/page-content';
import { SideBar } from '@/components/layout/admin/components/side-bar';
import { context } from '@/context';
import { useDispatchWorkbenchStore } from '@/stores/dispatch-workbench';

/**
 * AI.GEN lines=1-35
 * 管理后台布局组件 - 应用缩放功能
 */
export const LayoutAdmin = () => {
  const location = useLocation();
  const zoom = useDispatchWorkbenchStore((state) => state.zoom);
  const { orderBusinessType, setOrderBusinessType } =
    useDispatchWorkbenchStore();

  // 应用缩放功能
  useEffect(() => {
    const docEl = document.documentElement;
    docEl.style.cssText = `zoom:${zoom}%`;
  }, [zoom]);

  // 获取用户信息并根据权限设置订单业务类型
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const res = await apiDispatchAuthInformation();
        const hpType = res.hpType;
        const pfType = res.pfType;

        // 存储扩展用户信息到 context
        context.user.setExtendedUserInfo({
          userNick: res.userNick ?? null,
          hpType: hpType ?? null,
          pfType: pfType ?? null,
          cities: null, // 该接口不返回城市列表
        });

        // 根据用户权限设置订单业务类型（参考旧项目的 getOrderBusinessType 逻辑）
        const filteredOrderBusinessType: OrderBusinessType[] = [];

        if (orderBusinessType.length > 0) {
          // 如果已有订单类型，则根据权限过滤
          if (
            hpType === UserPermissionType.Enabled &&
            orderBusinessType.includes(OrderBusinessType.HP)
          ) {
            filteredOrderBusinessType.push(OrderBusinessType.HP);
          }
          if (
            pfType === UserPermissionType.Enabled &&
            orderBusinessType.includes(OrderBusinessType.PF)
          ) {
            filteredOrderBusinessType.push(OrderBusinessType.PF);
          }
        }

        // 如果过滤后的订单类型与当前不同，则更新
        if (
          filteredOrderBusinessType.length > 0 &&
          JSON.stringify(filteredOrderBusinessType.sort()) !==
            JSON.stringify([...orderBusinessType].sort())
        ) {
          setOrderBusinessType(filteredOrderBusinessType);
        }
      } catch (error) {
        // 静默失败，使用缓存数据
      }
    };

    // 每次组件挂载时都获取用户信息（确保数据是最新的）
    fetchUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={style.reactAdmin}>
      {!location.search.includes('sourceSiteUri=1') ? (
        <>
          <SideBar></SideBar>
          <div className={classNames(style.content, 'flex-column')}>
            <PageContent></PageContent>
          </div>
        </>
      ) : (
        <PageContent></PageContent>
      )}
    </div>
  );
};
